import { post } from "@/utils/utils";
// 客户群相关接口
const customerBase = {
    state: {},
    mutations: {
        QUERY_GROUP_LIST() {},
        ADD_CUSTOMER_BASE_GROUP() {},
        DEL_CUSTOMER_BASE_GROUP() {},
        QUERY_CUSTOMER_BASE_TEMPLATE_INFO() {},
        EDIT_CUSTOMER_BASE_TEMPLATE_INFO() {},
        DEL_CUSTOMER_BASE_TEMPLATE_INFO() {},
        ADD_CUSTOMER_BASE_TEMPLATE_INFO() {},
        QUERY_CUSTOMER_BASE_BQ_LIST() {},
        QUERY_GROUP_OWNER_LIST() {},
        QUERY_WECHAT_GROUP_LIST() {},
        EDIT_WECHAT_GROUP_CATEGORY_NAME() {},
        GET_INIT_CUSTOMER_SERVICE_URL() {},
        CUSTOMER_SERVICE_INIT_CONFIG() {},
        CUSTOMER_SERVICE_GET_INIT_INFO() {},
        QUERY_CUSTOMER_SERVICE_GROUP_LIST() {},
        SAVE_CUSTOMER_SERVICE_GROUP() {},
        EDIT_CUSTOMER_SERVICE_GROUP() {},
        QUERY_SERIVCE_LINK() {},
        QUERY_SERVICE_LIST() {},
        QUERY_KEFU_APP_LIST() {},
        SAVE_CUSTOMER_SERVICE_STRATEGY() {},
        QUERY_CUSTOMER_SERVICE_STRATEGY_LIST() {},
        EDIT_CUSTOMER_SERVICE_STRATEGY() {},
        DEL_CUSTOMER_SERVICE_STRATEGY() {},
        GET_STORE_WECHAT_DEPARTMENTS() {},
        GET_STORE_WECHAT_DEPARTMENT_MEMBERS() {},
        QUERY_GOODS_ORDER_RELATION() {},
        GET_BY_QUERY_NAME() {}
    },
    actions: {
        queryCustomerBaseGroupList({ commit }, params) {
            return post({
                commit,
                url: `/qywx/group/category/list?storeCode=`+ params.storeCode,
                name: "QUERY_GROUP_LIST",
                params
            });
        },
        addCustomerBaseGroup({ commit }, params) {
            return post({
                commit,
                url: `/qywx/group/category/add`,
                name: "ADD_CUSTOMER_BASE_GROUP",
                params
            });
        },
        delCustomerBaseGroup({ commit }, params) {
            return post({
                commit,
                url: `/qywx/group/category/delete`,
                name: "DEL_CUSTOMER_BASE_GROUP",
                params
            });
        },
        queryCustomerBaseTemplateInfo({ commit }, params) {
            return post({
                commit,
                url: `/qywx/group/template/get`,
                name: "QUERY_CUSTOMER_BASE_TEMPLATE_INFO",
                params
            });
        },
        editCustomerBaseTemplateInfo({ commit }, params) {
            return post({
                commit,
                url: `/qywx/group/template/update`,
                name: "EDIT_CUSTOMER_BASE_TEMPLATE_INFO",
                params
            });
        },
        delCustomerBaseTemplateInfo({ commit }, params) {
            return post({
                commit,
                url: `/qywx/group/template/delete`,
                name: "DEL_CUSTOMER_BASE_TEMPLATE_INFO",
                params
            });
        },
        addCustomerBaseTemplateInfo({ commit }, params) {
            return post({
                commit,
                url: `/qywx/group/template/create`,
                name: "ADD_CUSTOMER_BASE_TEMPLATE_INFO",
                params
            });
        },
        queryCustomerBaseBqList({ commit }, params) {
            return post({
                commit,
                url: `/qywx/group/category/tags`,
                name: "QUERY_CUSTOMER_BASE_BQ_LIST",
                params
            });
        },
        queryGroupOwnerList({ commit }, params) {
            return post({
                commit,
                url: `/qywx/group/owners`,
                name: "QUERY_GROUP_OWNER_LIST",
                params
            });
        },
        queryWechatGroupList({ commit }, params) {
            return post({
                commit,
                url: `/qywx/group/list`,
                name: "QUERY_WECHAT_GROUP_LIST",
                params
            });
        },
        editWechatGroupCategoryName({ commit }, params) {
            return post({
                commit,
                url: `/qywx/group/category/update`,
                name: "EDIT_WECHAT_GROUP_CATEGORY_NAME",
                params
            });
        },
        getInitCustomerServiceUrl({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/fk/callback/url`,
                name: "GET_INIT_CUSTOMER_SERVICE_URL",
                params
            });
        },
        customerServiceInitConfig({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/fk/config`,
                name: "CUSTOMER_SERVICE_INIT_CONFIG",
                params
            });
        },
        customerServiceGetInitInfo({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/fk/config/info`,
                name: "CUSTOMER_SERVICE_GET_INIT_INFO",
                params
            });
        },
        queryCustomerServiceGroupList({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/fk/list`,
                name: "QUERY_CUSTOMER_SERVICE_GROUP_LIST",
                params
            });
        },
        saveCustomerServiceGroup({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/fk/add`,
                name: "SAVE_CUSTOMER_SERVICE_GROUP",
                params
            });
        },
        editCustomerServiceGroup({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/fk/update`,
                name: "EDIT_CUSTOMER_SERVICE_GROUP",
                params
            });
        },
        querySerivceLink({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/fk/url?kfId=` + params.kfId,
                name: "QUERY_SERIVCE_LINK",
                params
            });
        },
        queryCustomerServiceList({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/fk/servicer?kfId=` + params.kfId,
                name: "QUERY_SERVICE_LIST",
                params
            });
        },
        saveCustomerServiceStrategy({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/fk/strategy/add`,
                name: "SAVE_CUSTOMER_SERVICE_STRATEGY",
                params
            });
        },
        queryCustomerServiceStrategyList({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/fk/strategy/list`,
                name: "QUERY_CUSTOMER_SERVICE_STRATEGY_LIST",
                params
            });
        },
        queryKefuAppList({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/fk/rel?storeCode=${params.storeCode}`,
                name: "QUERY_KEFU_APP_LIST",
            });
        },
        queryGoodsOrderRelation({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/fk/rel/create`,
                name: "QUERY_GOODS_ORDER_RELATION",
                params
            });
        },
        editCustomerServiceStrategy({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/fk/strategy/update`,
                name: "EDIT_CUSTOMER_SERVICE_STRATEGY",
                params
            });
        },
        delCustomerServiceStrategy({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/fk/strategy/delete?id=` + params.id,
                name: "DEL_CUSTOMER_SERVICE_STRATEGY",
                params
            });
        },
        getStoreWechatDepartments({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/departments`,
                name: "GET_STORE_WECHAT_DEPARTMENTS",
                params
            });
        },
        getStoreWechatDepartmentEmployees({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/department/members?queryName=${params.departmentId}&queryType=department`,
                name: "GET_STORE_WECHAT_DEPARTMENT_MEMBERS",
                params
            });
        },
        getByQueryName({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/department/members?queryName=${params.queryName}&queryType=search`,
                name: "GET_BY_QUERY_NAME",
                params
            });
        },
        queryStrategyLinkUrl({ commit }, params) {
            return post({
                commit,
                url: `/company/wechat/fk/strategy/url`,
                name: "QUERY_STRATEGY_LINK_URL",
                params
            });
        },
    },
};

export default customerBase;
